<template>
  <cc-search-overlay
    v-model="productName"
    placeholder="搜索订单号"
    v-bind="$attrs"
    v-on="$listeners"
    @cacel="cancel"
    @search="search()"
     >
    <van-list
      class="goods-list"
      @click.stop
      style="background:#f5f5f5"
      v-show="request"
      v-model="m_loading"
      :finished="m_finished"
      :finished-text="m_finishedText"
      @load="mHandlePullUpLoadMore"
      :immediate-check="m_immediateCheck"
    >
      <not-goods  v-if="request && list.length === 0 && m_loading === false"/>
      <goods-item
        v-for="(item,index) in list"
        :item="item"
        :key="index"
        :isReplace='isReplace'
        @changeLoad="changeLoad"
      >
      </goods-item>
    </van-list>
  </cc-search-overlay>
</template>

<script>
import { loadOrderList } from '~fetch/manage-center/order-management'
import NotGoods from '../components/not-goods'
import ListMixin from '@/mixins/list'
import GoodsItem from './item'
import { ResultCode } from '~const/ResultCode'
import CountDownMixin from '~mixins/countDown'

export default {
  name: 'search-overlay',
  mixins: [ListMixin, CountDownMixin],
  components: {
    GoodsItem,
    NotGoods
  },
  data () {
    return {
      productName: '',
      list: [],
      request: false,
      isReplace: ''
    }
  },
  methods: {
    judgeTime (item) {
      return parseInt(+item.over_time - +item.now_time)
    },
    cancel () {
      this.$emit('transparency', false)
      this.productName = ''
      this.request = false
      this.list = []
    },
    search () {
      this.m_page.curr = 1
      this.m_loading = false
      this.m_finishedText = ''
      this.list = []
      this.loadData()
    },
    async loadData (reset) {
      // 先清空原有的数据再加载
      if (reset) {
        this.list = []
      }
      this.mRequest()
      var params = {
        page: this.m_page.curr,
        limit: this.m_page.limit,
        order_state: 0,
        order_number: this.productName

      }
      let { data, status } = await loadOrderList(params)
      // let data = await loadOrderList(params)
      if (status === ResultCode.SUCCESS) {
        this.showSkeleton = false
        this.isLoading = false
        this.request = true
        if (data.order_data.length === 0) {
          this.mEnd()
        // 全部数据加载完成
          this.m_finishedText = ''
        } else {
        // 倒计时
          this.isReplace = data.is_replace
          data.order_data.forEach(item => {
            item.now_time = data.now_time
            this.$set(item, 'countDown', {
              d: '',
              h: '',
              m: '',
              s: ''
            })
            this.countDown(item)
            if (item.countDown.h === 0 && item.countDown.m === 0 && item.countDown.s === 0) {
              item.countDown = 0
            }
          })
          this.list = [...this.list, ...data.order_data]
          if (data.order_data.length < 10) {
            this.mEnd()
            this.m_finishedText = '--我也是有底线的--'
          }
        }
        this.mSuccess()
      } else {
        this.mEnd()
      }
    },
    /**
     *  刷新页面
     */
    changeLoad () {
      const reset = true
      this.m_page.curr = 0
      this.loadData(reset)
    }
  }
}
</script>

<style scoped lang="scss">
  .goods-list{
    padding: 10px;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch
  }
</style>
